import { render, staticRenderFns } from "./WooSettings.vue?vue&type=template&id=db854b66"
import script from "./WooSettings.vue?vue&type=script&lang=js"
export * from "./WooSettings.vue?vue&type=script&lang=js"
import style0 from "./WooSettings.vue?vue&type=style&index=0&id=db854b66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports